import { CheckoutRedirectOrderStatus } from '@/constants/checkoutRedirectOrderStatus';
import { CheckoutContext } from '@/context/CheckoutContext';
import type { CheckoutData } from '@/types/checkout';
import { getEventDataForSdkEvents } from '@/utils/eventDataBuilder';
import { getRedirectLinkFromUrlParams } from '@/utils/params';
import { getPersistedRedirectUrl } from '@/utils/persistedRedirectUrl';
import { getRedirectUrlWithEventParams } from '@/utils/redirect';
import { useContext, useMemo } from 'react';

export function useFallbackRedirectLink(checkoutData?: CheckoutData) {
  const context = useContext(CheckoutContext);

  return useMemo(() => {
    const redirectLink =
      getRedirectLinkFromUrlParams() || context.redirectLink || checkoutData?.redirectUrl || getPersistedRedirectUrl();
    if (!redirectLink) return null;

    const orderId = context.redirectPayment?.orderId ?? context.orderId ?? checkoutData?.orderId;

    return getRedirectUrlWithEventParams(redirectLink, CheckoutRedirectOrderStatus.FAIL, {
      ...getEventDataForSdkEvents(checkoutData ?? context),
      orderId,
    });
  }, [checkoutData, context]);
}
